/*
 * Copyright (C) 2015 - 2018 Kosmos contact@kosmos.fr
 *
 * Projet: newsletter-webapp-contrib
 * Version: 7.2.0-BETA-0
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *         http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
(function ($) {
    $.extend($.fn.dataTable.defaults.oLanguage, {
        "sProcessing": "Processing...",
        "sSearch": "Filter",
        "sLengthMenu": "Display _MENU_ items",
        "sInfo": "_START_ to _END_ of _TOTAL_ items",
        "sInfoEmpty": "",
        "sInfoFiltered": "(filtered from _MAX_ total items)",
        "sInfoPostFix": "&nbsp;",
        "sLoadingRecords": "Loading...",
        "sZeroRecords": "No matching item found",
        "sEmptyTable": "No data available in the table",
        "oPaginate": {
            "sFirst": "First",
            "sPrevious": "Previous",
            "sNext": "Next",
            "sLast": "Last"
        },
        "oAria": {
            "sSortAscending": ": activate to sort column in ascending order",
            "sSortDescending": ": activate to sort column in descending order"
        }
    });
})(jQuery);